import { render, staticRenderFns } from "./AppAccordion.vue?vue&type=template&id=6acb24a5&scoped=true&"
import script from "./AppAccordion.vue?vue&type=script&lang=ts&"
export * from "./AppAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./AppAccordion.vue?vue&type=style&index=0&id=6acb24a5&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acb24a5",
  null
  
)

export default component.exports